// extracted by mini-css-extract-plugin
export default {"main":"Main_main__Uxwo5","fadeInBackground":"Main_fadeInBackground__R8as9"};